<template>
  <div
    class="bubble-holder"
    ref="bubbleHolder"/>
</template>
<script>
export default {
  mounted () {
    this.setBubble()
  },
  methods: {
    setBubble () {
      const holder = this.$refs.bubbleHolder
      if (holder !== undefined) {
        const bubble = document.createElement('span')
        const size = this.getRandomNumber(5, 30)
        bubble.classList.add('bubble')
        bubble.style.left = `${this.getRandomNumber(0, document.body.clientWidth)}px`
        bubble.style.transition = `top ${this.getRandomNumber(2, 12)}s linear`
        bubble.style.width = `${size}px`
        bubble.style.height = `${size}px`
        bubble.style.opacity = `${this.getRandomNumber(0.5, 3) / 10}`
        bubble.addEventListener('transitionend', this.destroyBubble)
        holder.appendChild(bubble)
        setTimeout(() => {
          bubble.style.top = '-50px'
        }, 100)
      }

      setTimeout(this.setBubble, this.getRandomNumber(200, 1500))
    },

    getRandomNumber (min, max) {
      return Math.round(min + Math.random() * (max - min))
    },

    destroyBubble (e) {
      const holder = this.$refs.bubbleHolder
      holder.removeChild(e.currentTarget)
    }
  }
}
</script>
<style lang="scss">
  .bubble-holder {
    width: 100vh;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
    z-index: 1;

    .bubble {
      display: block;
      position: absolute;
      top: 103%;
      border-radius: 50%;
      background-color: $nos-op3-light-blue;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Bubbles.vue